import { CustomText } from "components";
import React from "react";

export const LabelControl = ({ label = "", control = "" }) => {
  return (
    <div>
      <CustomText className="mb-2" variant="body2" color="inherit" bold={600}>
        {label ?? ""}
      </CustomText>
      {control}
    </div>
  );
};
